var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22331_34902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 39C30.2696 39 39 30.2696 39 19.5C39 8.73045 30.2696 0 19.5 0C8.73045 0 0 8.73045 0 19.5C0 30.2696 8.73045 39 19.5 39Z",
    fill: "#0158E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.292 13.243C27.137 13.0881 26.9267 13.0011 26.7075 13.0011C26.4883 13.0011 26.2781 13.0881 26.123 13.243L16.223 23.143L12.412 19.34C12.2555 19.1928 12.0477 19.1123 11.8328 19.1156C11.6179 19.1189 11.4128 19.2058 11.2608 19.3577C11.1088 19.5097 11.022 19.7149 11.0187 19.9298C11.0153 20.1447 11.0958 20.3524 11.243 20.509L15.634 24.903C15.7891 25.0579 15.9994 25.145 16.2185 25.145C16.4377 25.145 16.648 25.0579 16.803 24.903L27.292 14.412C27.447 14.2569 27.534 14.0467 27.534 13.8275C27.534 13.6083 27.447 13.3981 27.292 13.243Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22331_34902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick1);
export default __webpack_public_path__ + "static/media/Tick (1).dc61ca767a3757b75e8b22b7460042ab.svg";
export { ForwardRef as ReactComponent };